import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Contato', href: '#contato' },
];

const LOGO_LIGHT = "https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/4db97c909d754362143458713f99c024.png";
const LOGO_DARK = "https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/6592d466-9f10-4108-a53a-d4965cacfe95_LOGO-INTRE-ESCURA.png?v=52e8f22ab708b7c0b11f988d6fc0d72c";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-[#D6C4D6] shadow-sm' : 'bg-[#301531]'
        }`}
        style={{ height: '100px' }}
      >
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between md:justify-between">
          {/* Hamburger - mobile left */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i
              className={`text-2xl transition-all duration-300 ${
                scrolled ? 'ri-menu-line text-[#301531]' : 'ri-menu-line text-white'
              }`}
            />
          </button>

          {/* Logo - centered on mobile, left on desktop */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center cursor-pointer h-full py-2 absolute left-1/2 -translate-x-1/2 md:static md:left-auto md:translate-x-0"
          >
            <img
              src={scrolled ? LOGO_DARK : LOGO_LIGHT}
              alt="INTRÊ Arquitetura"
              className="h-full w-auto object-contain transition-all duration-500"
            />
          </a>

          {/* Desktop Menu */}
          <ul className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className={`font-montserrat font-medium text-sm tracking-wide transition-all duration-300 relative group cursor-pointer whitespace-nowrap ${
                    scrolled ? 'text-[#301531]' : 'text-white'
                  }`}
                >
                  {link.label}
                  <span
                    className={`absolute -bottom-1 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full ${
                      scrolled ? 'bg-[#301531]' : 'bg-[#D6C4D6]'
                    }`}
                  />
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <a
            href="https://wa.me/5511930672567"
            target="_blank"
            rel="nofollow noreferrer"
            className={`hidden md:flex items-center gap-2 px-6 py-2.5 rounded-full font-montserrat font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'bg-[#301531] text-white hover:bg-[#4a2050]'
                : 'bg-white/10 border border-white/40 text-white hover:bg-white/20'
            }`}
          >
            <i className="ri-whatsapp-line text-base" />
            Solicitar atendimento
          </a>

          {/* Spacer mobile right (to balance hamburger) */}
          <div className="md:hidden w-10 h-10" />
        </div>
      </nav>

      {/* Mobile Menu - dropdown below navbar */}
      <div
        className={`fixed top-[100px] left-0 right-0 z-40 md:hidden transition-all duration-400 overflow-hidden ${
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{ background: '#301531' }}
      >
        <div className="flex flex-col items-center justify-center gap-1 py-6 px-6">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="w-full text-center font-montserrat text-white text-base font-medium tracking-widest uppercase py-3 border-b border-white/10 hover:text-[#D6C4D6] transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/5511930672567"
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-4 flex items-center justify-center gap-2 w-full max-w-xs px-6 py-3 rounded-full bg-white text-[#301531] font-montserrat font-bold text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base" />
            Solicitar atendimento
          </a>
        </div>
      </div>

      {/* Backdrop */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-30 md:hidden bg-black/40"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </>
  );
}
